import React from 'react';
import { CircleIcon } from '@ubeya/shared-web/components';

const ActionsColumnHeader = ({ tooltip, isLoading, icon, onClick }) => {
  if (!icon || !onClick) return null;

  return <CircleIcon tooltip={tooltip} isLoading={isLoading} icon={icon} onClick={onClick} />;
};

export default ActionsColumnHeader;
